<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-spacer />
              <v-col
                cols="12"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="yearFilter"
                  clearable
                  :items="years"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-socso-dialog-copy
                  v-if="$hasPermissionTo(['copy socso'])"
                  :available-years="years"
                  @created="handleDetailCopied"
                />
              </v-col>

              <v-col
                v-if="$hasPermissionTo(['create socso'])"
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-socso-dialog-create
                  @created="loadSocso"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :headers="headers"
            :loading="tableLoading"
            :search="search"
            :items="filteredSocso"
          >
            <template v-slot:item.wages_from="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.wages_from) }}
                </span>
              </div>
            </template>

            <template v-slot:item.wages_to="{ item }">
              <div>
                <span>
                  {{ item.wages_to == '2147483647'? 'Infinity' :currencyFormatting(item.wages_to) }}  
                </span>
              </div>
            </template>

            <template v-slot:item.first_category_employer_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.first_category_employer_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.first_category_employee_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.first_category_employee_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.first_category_total_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.first_category_total_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.second_category_employer_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.second_category_employer_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <payroll-setup-socso-dialog-edit
                v-if="$hasPermissionTo(['update socso'])"
                :socso="item"
                @updated="loadSocso"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollSetupSocsoDialogCopy: () => import('@/components/payroll/setup/socso/DialogCopy'), 
      PayrollSetupSocsoDialogCreate: () => import('@/components/payroll/setup/socso/DialogCreate'),
      PayrollSetupSocsoDialogEdit: () => import('@/components/payroll/setup/socso/DialogEdit'), 
    },
  
    data () {
      return {
        tableLoading: false,
        yearFilter: (new Date()).getFullYear(),
        years: [],   
        search: '',
        socsos: [],
        headers: [
          {
            text: 'From (RM)',
            align: 'right',
            value: 'wages_from',
            sortable: false,
          },
          {
            text: 'To (RM)',
            align: 'right',
            value: 'wages_to',
            sortable: false,
          },
          {
            text: 'FC Employer Contribution',
            align: 'right',
            value: 'first_category_employer_contribution',
            sortable: false,
          },
          {
            text: 'FC Employee Contribution',
            align: 'right',
            value: 'first_category_employee_contribution',
            sortable: false,
          },
          {
            text: 'FC Total Contribution',
            align: 'right',
            value: 'first_category_total_contribution',
            sortable: false,
          },
          {
            text: 'SC Employer Contribution',
            align: 'right',
            value: 'second_category_employer_contribution',
            sortable: false,
          },  
          {
            text: '',
            value: 'action',
            align: 'center',
            sortable: false,
          },
        ],
      }
    },
    computed: {
      filteredSocso () {
        return this.socsos.filter(socso => socso.year === this.yearFilter)
      },
    },
    created () {
      this.loadSocso()
    },  
    methods: {     
      loadSocso () {
        this.tableLoading = true

        Promise.all([
          this.$api.socso().listSocsoYear(),
          this.$api.socso().list(),
        ])
          .then(([year, socso]) => {
            this.years = year.data 
            this.socsos = _.orderBy(socso.data, ['wages_from'], ['asc'])      

            this.tableLoading = false
          })
      },

      currencyFormatting (item) {
        return (Math.round((item / 100) * 100) / 100).toFixed(2)
      },

      handleDetailCopied (year) {
        this.setYearFilter(year)
        this.loadSocso()
      },
      setYearFilter (year) {
        this.yearFilter = year
      },     
    },
  }
</script>
